var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"el-menu-vertical-demo, leftMenu",attrs:{"default-active":_vm.$route.meta.activeMenu || _vm.$route.path,"background-color":"#fff","active-text-color":"#1E469A"}},_vm._l((_vm.$store.getters['menu/sidebarRoutes']),function(route){return _c('sidebarItem',{key:route.path,attrs:{"item":route,"base-path":route.path}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }